import { useState, useEffect, useCallback } from "react";
import BackMethods from "../../back_component/BackMethods";
import { useNavigate, useLocation } from "react-router-dom";

export default function UsersManagementPage() {
    const location = useLocation();
    const navigate = useNavigate();
    const { backEnd_request } = BackMethods();

    const [users, setUsers] = useState([]);
    const [isLoading, setIsLoading] = useState(true);

    // حالات الربط مع الباك-أند
    const [searchTerm, setSearchTerm] = useState("");
    const [currentPage, setCurrentPage] = useState(1);
    const [totalCount, setTotalCount] = useState(0);
    const usersPerPage = 6;

    // دالة جلب البيانات من السيرفر بناءً على الصورة التي أرفقتها
    const fetchUsers = useCallback(async () => {
        setIsLoading(true);
        try {
            const res = await backEnd_request.get("/admin/UsersManagement", {
                params: {
                    SearchTerm: searchTerm,
                    Page: currentPage,
                    PageSize: usersPerPage
                }
            });
            // الباك أند عادة يرسل البيانات في data.users والعدد الكلي في data.totalCount
            setUsers(res.data.users || []);
            setTotalCount(res.data.totalCount || 0);
        } catch (error) {
            console.error(error);
        } finally {
            setIsLoading(false);
        }
    }, [searchTerm, currentPage, backEnd_request]);

    useEffect(() => {
        // Debounce للبحث لتقليل الطلبات
        const delayDebounceFn = setTimeout(() => {
            fetchUsers();
        }, 400);
        return () => clearTimeout(delayDebounceFn);
    }, [searchTerm, currentPage, fetchUsers]);

    const totalPages = Math.ceil(totalCount / usersPerPage);

    const paginate = (n) => {
        setCurrentPage(n);
        window.scrollTo({ top: 0, behavior: 'smooth' });
    };

    const handleDelete = async (userId) => {
        if (window.confirm("هل أنت متأكد من حذف هذا المستخدم؟")) {
            try {
                await backEnd_request.delete("/admin/UsersManagement/" + userId);
                fetchUsers();
            } catch (error) { console.error(error); }
        }
    };

    const handleToggleActive = async (userId, isActive) => {
        try {
            await backEnd_request.patch("/admin/UsersManagement/" + userId + "/toggle-active", { "isActive": !isActive });
            fetchUsers();
        } catch (error) { console.error(error); }
    };

    return (
        <div className="users-page-minimal" style={{ direction: 'rtl', fontFamily: 'Cairo, sans-serif' }}>
            <div className="container py-5 px-3">

                {/* --- عنوان الصفحة (نفس تصميمك) --- */}
                <div className="row align-items-end mb-5 g-3">
                    <div className="col-md-8">
                        <h2 className="fw-bold text-dark mb-2">إدارة المستخدمين</h2>
                        <div className="d-flex align-items-center gap-2 text-muted">
                            <span className="small">إجمالي الحسابات: <strong>{totalCount}</strong></span>
                        </div>
                    </div>
                    <div className="col-md-4 text-md-start">
                        <button className="btn btn-dark rounded-3 px-4 py-2 fw-medium shadow-sm" onClick={() => navigate("/admin/users-management/create")}>
                            <i className="bi bi-plus-lg ms-2"></i> إضافة مستخدم
                        </button>
                    </div>
                </div>

                {/* --- صندوق البحث (نفس تصميمك مع ربط الـ Value) --- */}
                <div className="bg-white border rounded-4 p-2 mb-5 shadow-sm">
                    <div className="row g-2">
                        <div className="col-md-12">
                            <div className="input-group border-0">
                                <span className="input-group-text bg-transparent border-0 text-muted"><i className="bi bi-search"></i></span>
                                <input
                                    type="text"
                                    className="form-control border-0 shadow-none py-2"
                                    placeholder="ابحث عن اسم أو حساب..."
                                    value={searchTerm}
                                    onChange={(e) => { setSearchTerm(e.target.value); setCurrentPage(1); }}
                                />
                            </div>
                        </div>
                    </div>
                </div>

                {/* --- قائمة المستخدمين (نفس تصميمك تماماً) --- */}
                {isLoading ? (
                    <div className="text-center py-5"><div className="spinner-border spinner-border-sm text-secondary"></div></div>
                ) : (
                    <>
                        <div className="users-stack">
                            {users.map((user) => (
                                <div key={user.userId} className="minimal-card bg-white border rounded-4 p-3 mb-3 transition-all">
                                    <div className="row align-items-center g-3">
                                        <div className="col-lg-4 col-md-5">
                                            <div className="d-flex align-items-center gap-3">
                                                <div className={`avatar-square ${user.isActive ? 'active' : 'inactive'}`}>
                                                    {user.firstName?.charAt(0)}{user.lastName?.charAt(0)}
                                                </div>
                                                <div className="text-truncate">
                                                    <h6 className="fw-bold mb-0 text-dark">{user.firstName} {user.lastName}</h6>
                                                    <span className="text-muted small">{user.username}</span>
                                                </div>
                                            </div>
                                        </div>

                                        <div className="col-lg-5 col-md-7">
                                            <div className="d-flex flex-wrap justify-content-between gap-2 border-end-md px-md-4">
                                                <div className="info-box">
                                                    <span className="d-block text-muted small">نوع الحساب</span>
                                                    <span className="fw-medium">{user.userTypeName}</span>
                                                </div>
                                                <div className="info-box">
                                                    <span className="d-block text-muted small">الحالة</span>
                                                    <span className={`fw-bold small ${user.isActive ? 'text-success' : 'text-muted'}`}>
                                                        {user.isActive ? 'نشط' : 'معطل'}
                                                    </span>
                                                </div>
                                            </div>
                                        </div>

                                        <div className="col-lg-3 col-12 text-md-start">
                                            <div className="d-flex gap-2 justify-content-lg-end justify-content-center">
                                                <button className="btn-minimal" title="تعديل" onClick={() => navigate(`/admin/users-management/edit/${user.userId}`)}><i className="bi bi-pencil"></i></button>
                                                <button className="btn-minimal" title="كلمة المرور" onClick={() => navigate(`/admin/users-management/change-password/${user.userId}`)}><i className="bi bi-key"></i></button>
                                                <button className={`btn-minimal ${user.isActive ? 'active' : ''}`} title="تغيير الحالة" onClick={() => handleToggleActive(user.userId, user.isActive)}><i className={`bi ${user.isActive ? 'bi-unlock' : 'bi-lock'}`}></i></button>
                                                <button className="btn-minimal text-danger-hover" title="حذف" onClick={() => handleDelete(user.userId)}><i className="bi bi-trash3"></i></button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            ))}
                        </div>

                        {/* --- الباجينيشن (تصميمك الأصلي الذي وضعته في الكود) --- */}
                        {totalPages > 1 && (
                            <div className="d-flex justify-content-center mt-5">
                                <div className="minimal-pagination">
                                    <button className="page-arrow" disabled={currentPage === 1} onClick={() => paginate(currentPage - 1)}>
                                        <i className="bi bi-chevron-right"></i>
                                    </button>
                                    <div className="page-numbers">
                                        {[...Array(totalPages)].map((_, i) => (
                                            <button key={i} className={`page-dot ${currentPage === i + 1 ? 'active' : ''}`} onClick={() => paginate(i + 1)}>
                                                {i + 1}
                                            </button>
                                        ))}
                                    </div>
                                    <button className="page-arrow" disabled={currentPage === totalPages} onClick={() => paginate(currentPage + 1)}>
                                        <i className="bi bi-chevron-left"></i>
                                    </button>
                                </div>
                            </div>
                        )}
                    </>
                )}
            </div>

            {/* الـ CSS الخاص بك بدون أي تغيير */}
            <style>{`
                .users-page-minimal { background-color: #f9fafb; min-height: 100vh; }
                .minimal-card { border-color: #eaecf0 !important; }
                .minimal-card:hover { border-color: #d0d5dd !important; background-color: #fcfcfd; }
                .avatar-square { width: 44px; height: 44px; border-radius: 10px; display: flex; align-items: center; justify-content: center; font-weight: 700; color: #475467; background: #f2f4f7; border: 1px solid #eaecf0; }
                .avatar-square.active { background: #eff8ff; color: #175cd3; border-color: #d1e9ff; }
                .btn-minimal { width: 36px; height: 36px; border-radius: 8px; border: 1px solid #eaecf0; background: white; color: #667085; transition: 0.2s; display: flex; align-items: center; justify-content: center; font-size: 0.9rem; }
                .btn-minimal:hover { background: #f9fafb; color: #101828; border-color: #d0d5dd; }
                .btn-minimal.active { color: #f79009; }
                .text-danger-hover:hover { color: #d92d20 !important; border-color: #fecdca !important; }
                .minimal-pagination { display: flex; align-items: center; gap: 12px; background: white; padding: 6px; border-radius: 12px; border: 1px solid #eaecf0; }
                .page-dot { width: 32px; height: 32px; border-radius: 8px; border: none; background: transparent; color: #667085; font-weight: 600; font-size: 0.9rem; }
                .page-dot.active { background: #f9fafb; color: #101828; border: 1px solid #eaecf0; }
                .page-arrow { background: transparent; border: none; color: #667085; font-size: 1rem; }
                .page-arrow:disabled { color: #d0d5dd; }
                @media (min-width: 768px) { .border-end-md { border-left: 1px solid #eaecf0; } }
                @media (max-width: 767px) { .minimal-card { text-align: center; } .info-box { flex: 1; } .btn-minimal { flex: 1; height: 42px; } }
            `}</style>
        </div>
    );
}